import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { apiUrl } from "../../constants";
import { comprimirImagen } from "../../core/utils";
import { MUTATION_MANUAL_TRANSFER_CHECKOUT_PAYMENT } from "../graphql/checkoutManualTransfer";
var MAX_RECEIPT_BYTES = 4 * 1024 * 1024;
/** Same JPEG quality as deliveryman dataphone receipt (AlertDeliveryDecision). */

var RECEIPT_COMPRESSION_QUALITY = 18;
var ALLOWED_RECEIPT_TYPES = ["image/jpeg", "image/png", "image/webp"];
export var validateManualTransferReceiptFile = function validateManualTransferReceiptFile(file) {
  if (!file) {
    return "Debes adjuntar el comprobante de la transferencia.";
  }

  if (ALLOWED_RECEIPT_TYPES.indexOf(file.type) === -1) {
    return "El comprobante debe ser una imagen JPG, PNG o WEBP.";
  }

  return null;
};

var buildReceiptFileName = function buildReceiptFileName(originalName) {
  var baseName = (originalName.replace(/\.[^.]+$/, "") || "comprobante").trim();
  return "".concat(baseName, ".jpg");
};
/**
 * Compress camera/gallery images before upload (same path as deliveryman receipt).
 */


export var prepareManualTransferReceiptFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var typeError, blob, compressed;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            typeError = validateManualTransferReceiptFile(file);

            if (!typeError) {
              _context.next = 3;
              break;
            }

            throw new Error(typeError);

          case 3:
            _context.next = 5;
            return comprimirImagen(file, RECEIPT_COMPRESSION_QUALITY);

          case 5:
            blob = _context.sent;

            if (blob) {
              _context.next = 8;
              break;
            }

            throw new Error("No se pudo procesar la imagen del comprobante. Intenta con otra foto.");

          case 8:
            compressed = new File([blob], buildReceiptFileName(file.name), {
              type: "image/jpeg",
              lastModified: Date.now()
            });

            if (!(compressed.size > MAX_RECEIPT_BYTES)) {
              _context.next = 11;
              break;
            }

            throw new Error("El comprobante sigue siendo muy pesado después de optimizarlo. Toma la foto más cerca al comprobante o elige otra imagen.");

          case 11:
            return _context.abrupt("return", compressed);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function prepareManualTransferReceiptFile(_x) {
    return _ref.apply(this, arguments);
  };
}();

var mapGraphqlUploadError = function mapGraphqlUploadError(response, rawBody) {
  if (response.status === 413) {
    return {
      errors: [{
        field: "paymentConfirmationFile",
        message: "El comprobante es demasiado pesado para enviar. Toma la foto de nuevo o elige otra imagen."
      }]
    };
  }

  if (response.status >= 500) {
    return {
      errors: [{
        message: "El servidor no pudo recibir el comprobante. Intenta de nuevo en unos momentos."
      }]
    };
  }

  if (!rawBody) {
    return {
      errors: [{
        message: "No se pudo enviar el comprobante. Verifica tu conexión e intenta de nuevo."
      }]
    };
  }

  try {
    var payload = JSON.parse(rawBody);

    if (payload.errors && payload.errors.length) {
      return {
        errors: payload.errors.map(function (error) {
          return {
            message: error.message || "No se pudo registrar el pago."
          };
        })
      };
    }

    var result = payload.data && payload.data.checkoutPaymentCreate;

    if (!result) {
      return {
        errors: [{
          message: "No se pudo registrar el pago."
        }]
      };
    }

    if (result.checkoutErrors && result.checkoutErrors.length) {
      return {
        errors: result.checkoutErrors
      };
    }

    return {
      data: {
        payment: result.payment
      }
    };
  } catch (_parseError) {
    return {
      errors: [{
        message: "No se pudo enviar el comprobante. Verifica tu conexión e intenta de nuevo."
      }]
    };
  }
};

export var createManualTransferCheckoutPayment = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
    var receiptFile, message, token, variables, formData, headers, response, rawBody;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return prepareManualTransferReceiptFile(input.receiptFile);

          case 3:
            receiptFile = _context2.sent;
            _context2.next = 10;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            message = _context2.t0 instanceof Error ? _context2.t0.message : "No se pudo procesar el comprobante.";
            return _context2.abrupt("return", {
              errors: [{
                message: message,
                field: "paymentConfirmationFile"
              }]
            });

          case 10:
            token = localStorage.getItem("token");
            variables = {
              checkoutId: input.checkoutId,
              input: {
                gateway: input.gateway,
                token: "manual_transfer",
                amount: input.amount,
                manualTransferChannelName: input.channelName,
                paymentConfirmationFile: null
              }
            };
            formData = new FormData();
            formData.append("operations", JSON.stringify({
              query: MUTATION_MANUAL_TRANSFER_CHECKOUT_PAYMENT,
              variables: variables
            }));
            formData.append("map", JSON.stringify({
              "0": ["variables.input.paymentConfirmationFile"]
            }));
            formData.append("0", receiptFile, receiptFile.name);
            headers = {};

            if (token) {
              headers.Authorization = "JWT ".concat(token);
            }

            if (apiUrl) {
              _context2.next = 20;
              break;
            }

            return _context2.abrupt("return", {
              errors: [{
                message: "No se pudo conectar con el servidor. Intenta de nuevo."
              }]
            });

          case 20:
            _context2.prev = 20;
            _context2.next = 23;
            return fetch(apiUrl, {
              method: "POST",
              headers: headers,
              body: formData
            });

          case 23:
            response = _context2.sent;
            _context2.next = 26;
            return response.text();

          case 26:
            rawBody = _context2.sent;

            if (response.ok) {
              _context2.next = 29;
              break;
            }

            return _context2.abrupt("return", mapGraphqlUploadError(response, rawBody));

          case 29:
            return _context2.abrupt("return", mapGraphqlUploadError(response, rawBody));

          case 32:
            _context2.prev = 32;
            _context2.t1 = _context2["catch"](20);
            return _context2.abrupt("return", {
              errors: [{
                message: "No se pudo enviar el comprobante. Verifica tu conexión e intenta de nuevo."
              }]
            });

          case 35:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6], [20, 32]]);
  }));

  return function createManualTransferCheckoutPayment(_x2) {
    return _ref2.apply(this, arguments);
  };
}();